/**
 * Import Vue and Application Needs
 */
import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import components from "./components";
import superscript from "./superscript";
import subscript from "./subscript";
import wysiwyg from "vue-wysiwyg";

const CustomPlugin = {
  install(Vue, options) {
    Vue.prototype.handleClick = (e) => {
      if (e.target.matches("a")) {
        let url = e.target.href;
        let target = e.target.target == "_blank" ? "_blank" : "_self";
        let dataId = e.target.dataset.id == null ? -1 : e.target.dataset.id;
        var isnativeapp = document.getElementById("isnativeapp");
        if (isnativeapp === undefined || isnativeapp === null) 
        {
          window.open(url,target);  
        }
        else{
            let data = {title:'',nodeid: dataId, href:url, target: target};
            window.Native('dataCallback', data);
        }	
      }
    }
  },
}

Vue.use(CustomPlugin)

/**
 * Use WYSIWYG
 */
Vue.use(wysiwyg, {
  hideModules: {
    justifyLeft: true,
    justifyCenter: true,
    justifyRight: true,
    code: true,
    separator: true,
    image: true
  },
  customModules: [superscript, subscript]
});

/**
 * Vue Configuration Settings
 */
Vue.config.productionTip = false;

/**
 * Require SNAP SVG
 */
const snap = require("imports-loader?this=>window,fix=>module.exports=0!snapsvg/dist/snap.svg.js");

/**
 * Generate Vue
 */
new Vue({
  snap,
  store,
  components,
  render: h => h(App),
  created() {
    const html = document.documentElement;
    html.setAttribute("lang", "en");
  }
}).$mount("#app");
